/* src/app/admin/audit-log/audit-log-result/values/audit-error.component.scss */
.audit-error-table {
  margin-bottom: 30px;
}
/*# sourceMappingURL=audit-error.component-FWGQTRS3.css.map */
